<template>
    <div class="file">
        <form @submit.prevent="onSubmit" enctype="multipart/form-data">
            <div class="fields">
                <input 
                type="file"
                ref="file"
                @change="onSelect"
                />
            </div>
            <!-- <div class="fields">
                <button :disabled="BotonPermitido">Submit</button>
            </div> -->
            <div class="message">
                <h5>{{message}}</h5>
            </div>
        </form>
    </div>
</template>
<script>
export default {
  name: 'FileUpload',
  data() {
    return {
      file:"",
      message:""
    }
  },
  computed: {
    BotonPermitido(){
      return !this.message == '';
    }
  },
  methods: {
    async onSelect(){
      if(this.$refs.file){
        //const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
        const allowedTypes = ["application/pdf"];
        const file = this.$refs.file.files[0];
        this.file = file;
        this.message = "";
        if(!allowedTypes.includes(file.type)){
          this.message = "Sólo se aceptan PDFs!";
        }
        else if(file.size > (1024*1024*2)){
          this.message = 'Sólo se aceptan PDFs de hasta 1Mb!';
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .message{
    color: red;
  }
</style>